
export const useTwilioConfiguration = () => {
  // Calls are generated from the backend - no frontend config check needed
  return {
    isTwilioConfigured: true,
  };
};
